export class EmployeesStatusWiseCountDto {
    active:number;
    inActive:number;
}